module.exports = __webpack_public_path__ + "static/media/plaza_felujitas_2.6ba9bb54.jpg";